<template>
</template>

<script>
    import $ from "jquery";
    // import TweenMax from "gsap/TweenMax";

    export default {
        props: {},
        data() {
            return {
                animationStarted: false
            };
        },
        methods: {
            startAnimation() {
                if (this.animationStarted) {
                    return
                }
                this.animationStarted = true


                var shapes = $(".back-map path")
                var line1 = $(".wrap-one-location.crozet .wrap-bar line")
                var line2 = $(".wrap-one-location.kerguelen .wrap-bar line")
                var line3 = $(".wrap-one-location.saintpaul .wrap-bar line")
                var tl = new TimelineMax()

                tl.fromTo(shapes, 3, {drawSVG: "0%"}, {drawSVG: "100%"}, 0.6)
                    .set(".back-map", {className: "-=white-line"}, "-=1.1")
                    .set(".back-map", {className: "+=show-fill"}, "-=1.1")
                    .set(".wrap-one-location.crozet .wrap-pin", {className: "+=show"}, "-=1")
                    .set(".wrap-one-location.kerguelen .wrap-pin", {className: "+=show"}, "-=0.8")
                    .set(".wrap-one-location.saintpaul .wrap-pin", {className: "+=show"}, "-=0.7")
                    .set(".wrap-one-location.saintpaul .wrap-full", {className: "+=show"}, "-=0.6")
                    .set(".wrap-one-location.kerguelen .wrap-full", {className: "+=show"}, "-=0.5")
                    .set(".wrap-one-location.crozet .wrap-full", {className: "+=show"}, "-=0.4")
                    .fromTo(line1, 1, {drawSVG: "0%"}, {drawSVG: "100%", ease: Power4.easeOut}, "-=0.4")
                    .fromTo(line2, 1, {drawSVG: "0%"}, {drawSVG: "100%", ease: Power4.easeOut}, "-=1")
                    .fromTo(line3, 1, {drawSVG: "0%"}, {drawSVG: "100%", ease: Power4.easeOut}, "-=1")
                    .set(".wrap-one-location.crozet .wrap-label", {className: "+=show"}, "-=1")
                    .set(".wrap-one-location.kerguelen .wrap-label", {className: "+=show"}, "-=0.8")
                    .set(".wrap-one-location.saintpaul .wrap-label", {className: "+=show"}, "-=0.6")
            }
        },
        mounted() {

        },
        destroyed() {
        }
    };
</script>
